import API from "../api/API";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { flattenObj } from "helpers/strapi";
import { Permission, useAuth } from "hooks/useAuth";
const qs = require("qs");

export const useVendorAPI = () => {
    const { user } = useAuth(Permission.USER_ONLY);

    const getOneVendor = async (id: string) => {
        try {
            const response = await API({
                requireAuth: true,
                token: user.jwt,
            }).get<any, any>(`vendors/${id}?populate=*`);

            return flattenObj(response.data);
        } catch (e) {
            return e;
        }
    };

    const useGetOneVendor = (id: string) =>
        useQuery(["GET_ONE_VENDOR", id], () => getOneVendor(id), {
            enabled: !!id,
        });

    const useGetAllVendor = (filter: any) => {
        const getAllVendor = async () => {
            const query = qs.stringify(
                {
                    populate: ["logo", "vendorPic.agent"],
                    filters: {
                        $or: filter?.filters ?? [],
                    },
                    pagination: {
                        page: filter?.pagination.page,
                        pageSize: filter?.pagination.pageSize,
                    },
                },
                {
                    encodeValuesOnly: true,
                }
            );

            try {
                const response = await API({
                    requireAuth: true,
                    token: user.jwt,
                }).get(`vendors?${query}`);

                return {
                    data: flattenObj(response.data.data),
                    meta: response.data.meta,
                };
            } catch (e) {
                throw new Error("Fetching vendors failed.");
            }
        };

        return useQuery(["GET_ALL_VENDOR", filter], getAllVendor, {
            enabled: !!filter, // Make sure to only enable when filter is not null
        });
    };

    const getOneVendorBySlug = async (slug: string) => {
        try {
            const query = qs.stringify(
                {
                    populate: "*",
                    filters: {
                        slug: {
                            $eq: slug,
                        },
                    },
                },
                {
                    encodeValuesOnly: true, // prettify URL
                }
            );

            const response = await API({
                requireAuth: true,
                token: user.jwt,
            }).get<any, any>(`vendors?${query}`);

            return flattenObj(response.data);
        } catch (e) {
            return e;
        }
    };

    const useGetOneVendorBySlug = (slug: string) =>
        useQuery(
            ["GET_ONE_VENDOR_BY_SLUG", slug],
            () => getOneVendorBySlug(slug),
            {
                enabled: !!slug,
            }
        );

    const useUpdateVendor = () =>
        useMutation(async (payload: any) => {
            const resp = await API({ requireAuth: true, token: user.jwt }).put<
                any,
                any
            >(`vendors/${payload.id}`, {
                data: { ...payload },
            });
            return flattenObj(resp);
        });

    return {
        useGetOneVendor,
        useGetOneVendorBySlug,
        useUpdateVendor,
        useGetAllVendor,
    };
};
